import React from "react";
import { useSelector } from "react-redux";

function Bottombar() {
  const isMobile = window.innerWidth <= 768;
  const disclaimer = useSelector((state) => state.dynamicStore.disclaimer);
  
  return (
    <>
   
      <div className="bottombar-container">
        {isMobile ? (
          <span className="f500-16px text-white">Disclaimer : </span>
        ) : (
          <div className="f500-16px text-white">Disclaimer : </div>
        )}
        <span className={isMobile ? "f400-14px text-white":"f400-16px text-white"}>
          {disclaimer}
        </span>
      </div>
    </>
  );
}

export default Bottombar;
